<template>
  <div class="page-wrapper">
<!--    <div class="flex-wrapper">-->
    <div style="width: 100%; height: 50px; text-align: left; padding-left: 50px; background-color: white; line-height: 50px;">
      <strong>Select Date</strong>
      <date-picker v-model="dateRange"  valueType="format" @change="dateRangeSelected" range></date-picker>
<!--      <input type="date" class="form-control" v-model="selectedDateFrom"/>-->
<!--      <input type="date" class="form-control" v-model="selectedDateTo"/>-->
      <select v-model="selectedMerchantId" style="height: 32px;">
        <option value="-1">All Shops</option>
        <option value="0">KOKORO</option>
        <option v-for="m in merchants" :value="m.id">{{m.title}} <span v-if="m.active === false"> (Inactive)</span></option>
      </select>
      <select v-model="selectedVendorId" style="height: 32px;">
        <option value="0">Select Vendor</option>
        <option v-for="v in vendors" :value="v.id">{{v.title}}</option>
      </select>
      <button class="btn btn-primary" v-on:click="getDayOrderList">Get</button>
    </div>
    <div style="width: 100%; height: calc(100% - 50px); overflow-y: scroll;">
      <table class="table">
        <tr class="sticky-header-row">
          <th>ID</th>
          <th>PO Number</th>
          <th class="text-left">Shop</th>
          <th class="text-left">Vendor</th>
          <!--                        <th>생성시간</th>-->
          <th>Delivery Date</th>
          <th>Sent</th>
          <th></th>
          <th>Confirmed</th>
          <th>Complete</th>

          <th>Total</th>
          <th>VAT</th>
          <th>DUE</th>
        </tr>
        <tbody v-if="orders.length > 0">
        <tr v-for="order in orders" v-on:click="openOrderItem(order.id)" class="hover-item"  v-bind:class="{'order-unconfirmed-row': order.confirmed === false}">
          <td>{{order.id}}</td>
          <td><b>{{order.poNumber}}</b></td>
          <td class="text-left">{{getMerchantName(order.merchantId)}}</td>
          <td class="text-left">{{getVendorName(order.vendorId)}}</td>
          <!--                        <td>{{dateString(order.createdTimestamp)}}</td>-->
          <td>{{convertDeliveryDate(order.deliveryDate)}}</td>
          <td>{{dateTimeString(order.orderSentTime)}}</td>
          <td><span v-if="order.imageUrls != null && order.imageUrls.length > 0" v-on:click.stop="invoiceView = JSON.parse(JSON.stringify(order));"><i class="fas fa-file-alt" style="color:blue;"></i></span></td>
          <td><span v-if="order.confirmed"><i class="fas fa-check"></i></span></td>
          <td><span v-if="order.state == 100"><i class="fas fa-check"></i></span></td>
          <td>{{(order.totalPrice/100.0).toFixed(2)}}</td>
          <td>{{(order.tax/100.0).toFixed(2)}}</td>
          <td>{{(order.finalDue/100.0).toFixed(2)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
<!--    </div>-->
    <transition name="slideup">
      <div class="item-container" v-if="vendorOrder != false" v-on:click="vendorOrder = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:900px; height:100%; padding-top:10px; overflow-y: auto; position: relative;">
            <table class="table" style="width:calc(100% - 20px); margin:auto;" v-if="vendorOrder.list.length > 0">
              <tr class="sticky-header-row text-left">
                <th>Item</th>
                <th class="text-center">Qty</th>
                <!--                <th>DN</th>-->
                <th class="text-right">NET</th>
                <th class="text-right">VAT</th>
                <th class="text-right">TOTAL</th>
                <!--                <th class="text-right">Payment</th>-->
                <!--                <th class="text-right">Remaining</th>-->
              </tr>
              <tbody>
              <tr v-for="order in vendorOrder.list" class="text-left">

                <td>{{order.title}}</td>
                <td class="text-center">{{order.amount}}</td>
                <!--                <td>{{order.orderType}}</td>-->
                <!--                <td><span v-if="order.deliveredTime > 0">{{getDateString(order.deliveredTime)}}</span></td>-->

                <!--                <td><span v-if="order.type !== 'summary' && order.deliveryNotes != null && order.deliveryNotes.length > 0"><i class="fas fa-file-alt"></i></span></td>-->
                <td class="text-right">{{(order.totalPrice/100.0).toFixed(2)}}</td>
                <td class="text-right">{{(order.tax/100.0).toFixed(2)}}</td>
                <td class="text-right">{{(order.finalDue/100.0).toFixed(2)}}</td>
                <!--                <td class="text-right">-->
                <!--                  <span v-if="order.orderType === 'sales' || order.type === 'summary'">{{(order.paid/100.0).toFixed(2)}}</span>-->
                <!--                  <span v-else-if="order.orderType === 'credit'">CR {{(order.finalDue/100.0).toFixed(2)}}</span>-->
                <!--                </td>-->
                <!--                <td class="text-right"><span v-if="order.orderType === 'sales'">{{((order.finalDue-order.paid)/100.0).toFixed(2)}}</span><span v-else>0.00</span></td>-->
              </tr>
              </tbody>
            </table>
          </div>
          <div style="width:calc(100% - 900px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h2>PO Number: {{vendorOrder.poNumber}}</h2>
            <h4>{{getMerchantName(vendorOrder.merchantId)}}<br>to<br>{{getVendorName(vendorOrder.vendorId)}}</h4>
            <hr>
            <table class="text-left">

              <tr>
                <td style="padding-right:20px;">Ordered Date </td>
                <td class="text-right">{{dateString(vendorOrder.orderSentTime)}}</td>
              </tr>
              <tr>
                <td>Confirmed </td>
                <td class="text-right">{{dateString(vendorOrder.confirmedTime)}}</td>
              </tr>
              <tr>
                <td>NET </td>
                <td class="text-right">{{(vendorOrder.totalPrice/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>VAT </td>
                <td class="text-right">{{(vendorOrder.tax/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>GROSS </td>
                <td class="text-right">{{(vendorOrder.finalDue/100.0).toFixed(2)}}</td>
              </tr>
            </table>

            <hr/>
            <button v-if="vendorOrder.imageUrls != null && vendorOrder.imageUrls.length > 0" class="btn btn-success" v-on:click="invoiceView = vendorOrder;">View Order PDF</button>
            <button style="margin-left: 50px;" class="btn btn-danger" v-on:click="sendMerchantOrderToVendor(vendorOrder)">Send Order Again</button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slideup">
      <div class="item-container" v-if="invoiceView != false" v-on:click="invoiceView = false">
        <div style="position: absolute; width: 80%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
          <div style="width:800px; height:100%; padding-top:10px;">
            <embed v-if="invoiceView.imageUrls != null && invoiceView.imageUrls.length > 0":src="'https://storage.googleapis.com/kokoro-294123.appspot.com/' + invoiceView.imageUrls[0]" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
            <h3 v-else>No PDF Found</h3>
          </div>
          <div style="width:calc(100% - 800px); height:100%; overflow-y: scroll; padding:20px; text-align: left;">
            <h4>{{getMerchantName(invoiceView.merchantId)}}<br>to<br>{{getVendorName(invoiceView.vendorId)}}</h4>
            <hr>
            <table class="text-left">

              <tr>
                <td style="padding-right:20px;">Ordered Date </td>
                <td class="text-right">{{dateString(invoiceView.orderSentTime)}}</td>
              </tr>
              <tr>
                <td>Confirmed </td>
                <td class="text-right">{{dateString(invoiceView.confirmedTime)}}</td>
              </tr>
              <tr>
                <td>NET </td>
                <td class="text-right">{{(invoiceView.totalPrice/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>VAT </td>
                <td class="text-right">{{(invoiceView.tax/100.0).toFixed(2)}}</td>
              </tr>
              <tr>
                <td>GROSS </td>
                <td class="text-right">{{(invoiceView.finalDue/100.0).toFixed(2)}}</td>
              </tr>
            </table>


          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {millisToDate, millisToReadable, setLastPage, showDialog, timeToLocaleDateYear} from "../api/utils";
    import {getUserByToken} from "../api/user";
    import {getMerchants} from "../api/merchant";
  import {queryOrders} from "../api/order";
  import {
    getVendorOrder,
    getVendorOrders,
    getVendors,
    sendMerchantVendorOrder,
    vendorOrderStatusString
  } from "../api/vendors";
import DatePicker from 'vue2-datepicker';

    export default {
      name: "VendorOrders",
      data() {
          return {
            orders:[],
            merchants:[],
            vendors:[],
            selectedMerchantId:-1,
            selectedVendorId:0,
            currentOrder:false,
            selectedDateFrom:'',
            selectedDateTo:'',
            vendorOrder: false,
            invoiceView:false,
            dateRange:null,
          }
      },
      components: {
        DatePicker,
      },
      created() {
        setLastPage(this.$route.path);
        // if(localStorage.getItem("vendor-order-date-from") !== null) {
        //   this.$data.selectedDateFrom = localStorage.getItem("vendor-order-date-from");
        // } else {
        //   this.$data.selectedDateFrom = millisToDate(new Date().getTime(), '-');
        // }
        // if(localStorage.getItem("vendor-order-date-to") !== null) {
        //   this.$data.selectedDateTo = localStorage.getItem("vendor-order-date-to");
        // } else {
        //   this.$data.selectedDateTo = millisToDate(new Date().getTime(), '-');
        // }
        let today = new Date();
        let dateTo = millisToDate(today.getTime(), '-');
        today.setDate(today.getDate()-5);

        let dateFrom = millisToDate(today.getTime(), '-');
        this.$data.dateRange = [dateFrom, dateTo];

      },
      mounted() {
        this.getMyInfo();
      },
      methods: {
        dummy: function(){},
        dateString:millisToDate,
        dateTimeString:millisToReadable,
        orderStateString: vendorOrderStatusString,
        convertDeliveryDate: function(date) {

          if(date === null || date.length !== 10) {
            return date;
          }
          let d = new Date(date);
          return timeToLocaleDateYear(d.getTime());
        },
        dateRangeSelected: function() {
          console.log("dateRangeSelected")
          console.log(this.$data.dateRange)

          if(this.$data.dateRange.length !== 2) {
            return;
          }

          if(this.$data.dateRange[0] > this.$data.dateRange[1]) {
            let temp = this.$data.dateRange[1];
            this.$data.dateRange[0] = this.$data.dateRange[1];
            this.$data.dateRange[1] = temp;
          }

        },
        getMyInfo: function() {
          let self = this;
          getUserByToken()
            .then(function(data) {
              self.$data.user = data;
              console.log("user acquired");
              console.log(self.$data.user);
              // if(self.$data.me.type === 'ROLE_ADMIN') {
              self.getMerchantList();
              self.getVendorList();
              // }
            })
            .catch(function(err) {

            })
        },
        getVendorList: function() {
          let self = this;
          getVendors('vendor')
            .then(function(data) {
              if(data.success == true) {
                self.$data.vendors = data.item;
              }
            })
            .catch(function(err) {
              console.log(err);
            })
        },
        getMerchantList: function() {
          let self = this;
          getMerchants()
            .then(function(data) {
              if(data.success == true) {
                let deactivatedList = [];
                for(let i = 0 ; i < data.item.length ; i++) {
                  if(data.item[i].active === true) {
                    self.$data.merchants.push(data.item[i]);
                  } else {
                    deactivatedList.push(data.item[i]);
                    console.log(data.item[i].title + ' is ' + data.item[i].active);
                  }
                }
                if(deactivatedList.length > 0) {
                  for(let i = 0 ; i < deactivatedList.length ; i++) {
                    self.$data.merchants.push(deactivatedList[i]);
                  }

                }
                self.getDayOrderList();
              } else {

              }
            })
        },
        getMerchantName: function(id) {
          if(id == 0) {
            return 'KOKORO';
          }
          if(this.$data.merchants.length == 0) {
            return 'Not Found';
          }


          for(let i = 0 ; i < this.$data.merchants.length ; i++) {
            if(this.$data.merchants[i].id == id) {
              return this.$data.merchants[i].title;
            }
          }
          return 'Unknown(' + id + ')';
        },
        getVendorName: function(id) {
          if(this.$data.vendors.length == 0) {
            return 'Not Found';
          }

          for(let i = 0 ; i < this.$data.vendors.length ; i++) {
            if(this.$data.vendors[i].id == id) {
              return this.$data.vendors[i].title;
            }
          }
          return 'Unknown(' + id + ')';
        },
        getDayOrderList: function() {
          let self = this;
          this.$data.currentOrder = false;
          this.$data.orders = [];
          // localStorage.setItem("vendor-order-date-from", this.$data.selectedDateFrom);
          // localStorage.setItem("vendor-order-date-to", this.$data.selectedDateTo);
          let start = new Date(this.$data.dateRange[0]);
          start.setHours(0,0,0,0);
          let end = new Date(this.$data.dateRange[1]);
          end.setHours(23,59,59,999);
          let query = "vendorId=" + this.$data.selectedVendorId +  "&sentFrom=" + start.getTime() + "&sentTo=" + end.getTime();
          query += "&stateFrom=0&stateTo=100";
          if(this.$data.selectedMerchantId >= 0) {
            query += "&merchantId=" + this.$data.selectedMerchantId;
          } else{
            query += "&all=true";
          }
          console.log(query);
          // let query = "deliveryFrom=" + this.$data.selectedDateFrom + '&deliveryTo=' + this.$data.selectedDateTo + "&listOnly=true";
          //this.$data.newOrderDeliveryDate = this.$data.selectedDate;
          console.log("get query " + query);
          self.$data.orders = [];
          getVendorOrders(query)
            .then(function(data) {
              if(data.success == true) {
                data.item.sort(function(a, b) {
                  return b.orderSentTime - a.orderSentTime;
                })
                self.$data.orders = data.item;
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {

            })
        },
        openOrderItem: function(id) {
          let self = this;
          getVendorOrder(id)
          .then(function(data) {
            if(data.success) {
              self.vendorOrder = data.item;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response +')';
            }
            showDialog(msg, "ERROR");
          })
        },
        sendMerchantOrderToVendor: function(vendorOrder) {
          let self = this;
          sendMerchantVendorOrder(vendorOrder.id)
            .then(function(data) {
              if(data.success === true) {
                self.vendorOrder = data.item;
                showDialog("Email has been sent");
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err) {
              let msg = err;
              if(err.response != undefined) {
                msg += ' (' + err.response +')';
              }
              showDialog(msg, "ERROR");
            })
        }
      }
    }
</script>

<style scoped>
.order-unconfirmed-row {
  background-color: #FFCECE;
}
</style>



// WEBPACK FOOTER //
// src/components/VendorOrders.vue